import React, {useState, useCallback} from 'react'
import {useDropzone} from 'react-dropzone';

// DemoUploadAudioDiv
function DemoUploadAudioDiv(props) {

  let [files, setFiles] = useState("")

  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files
    
    props.fileSlected(acceptedFiles)

    if (acceptedFiles.length !== 1) {
      return
    }

    const _files = acceptedFiles.map(file => (
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li>
    ));
    setFiles(_files)

  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

  return (
    <div {...getRootProps({className: 'dropzone'})}>
      <input {...getInputProps()} />
      <p>音声ファイルをドロップ</p>
    </div>
  );
}

export default DemoUploadAudioDiv
